import * as tutorialRuleset from './tutorial.ruleset';
import { tutorialSchema } from './tutorial.schema';
import { tutorialModifiers } from './tutorial.modifiers';
import { tutorialGetters } from './tutorial.getters';
import { tutorialActions } from './tutorial.actions';
import { Inventory } from '../inventory';
import { ReplicantModuleState } from '../../utils';
import { Immutable } from '@play-co/replicant';

export type Tutorial = typeof Tutorial;
// eslint-disable-next-line no-redeclare
export namespace Tutorial {
  export const $DEPENDENCIES = { Inventory };

  export const ruleset = tutorialRuleset;
  export const schema = tutorialSchema;
  export const getters = tutorialGetters;
  export const modifiers = tutorialModifiers;
  export const actions = tutorialActions(Tutorial, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Tutorial>;
  export type State = Immutable<MutableState>;
}
